import { render, staticRenderFns } from "./OrganizationHelpModal.vue?vue&type=template&id=0f7b74bb&scoped=true&"
import script from "./OrganizationHelpModal.vue?vue&type=script&lang=ts&"
export * from "./OrganizationHelpModal.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationHelpModal.vue?vue&type=style&index=0&id=0f7b74bb&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7b74bb",
  null
  
)

export default component.exports